import React, { useContext, useState, useEffect } from 'react';
import { AuthContext } from '../../providers/AuthProvider';
import './TrialPlanBanner.css';
import ButtonSecondary from '../Buttons/ButtonSecondary/ButtonSecondary';

const TrialPlanBanner = () => {
  const { user } = useContext(AuthContext);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(user?.subscription?.paymentPlan?.trial === true);
  }, [user?.subscription?.paymentPlan?.trial]);

  const handleUpgrade = () => {
    window.location.href = '/companies/settings/change-plan';
  };

  if (!isVisible) return null;

  return (
    <div className="trialPlanBanner">
      <div className="trialPlanBannerContent">
        <div className="trialPlanBannerText">
          Você está usando o <strong>Plano {user?.subscription?.paymentPlan?.name}</strong>. Para aproveitar os recursos da plataforma, contrate um plano.
        </div>
        <ButtonSecondary
          text="Ver Planos"
          fontWeight={700}
          fontSize="14px"
          onClick={handleUpgrade}
        />
      </div>
    </div>
  );
};

export default TrialPlanBanner;

